import React, { useState, useEffect } from 'react';
import { increment, getFirestore, collection, getDocs, doc, setDoc, getDoc, updateDoc, deleteDoc, where, query } from "firebase/firestore";
import { getAuth } from 'firebase/auth';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import appFirebase from "../Firebase/Firebase";
import Footer from '../Components/footer';
import Navbar from '../Components/NavBarV2';
import Lateral3 from '../images/lateral3.png';
import QR from '../images/QRDeUna.png'
import Lateral4 from '../images/lateral4.png';
import Lateral5 from '../images/lateral5.png';
import Modal from 'react-modal';
import './Membresias.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { FaCreditCard, FaUniversity } from "react-icons/fa";
import ProdubancoLogo from '../images/Produbanco_Logo.png';
import PaypalButton from './Pagos/PaypalIntegration';
//import './ModalPayment.css';
import DeUnaLogo from '../img/icon-deuna.png';
Modal.setAppElement('#root');

const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);

const Membresias = () => {
  const [coinPackages, setCoinPackages] = useState([]);
  const [user, setUser] = useState(null);
  const [role, setRole] = useState('');
  const [selectedPackage, setSelectedPackage] = useState(null); // Paquete seleccionado
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal de compra
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false); // Modal de confirmación
  const [confirmationMessage, setConfirmationMessage] = useState(''); // Mensaje de confirmación
  const [pendingPurchases, setPendingPurchases] = useState([]); // Compras pendientes
  const [isValidationModalOpen, setIsValidationModalOpen] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');
  const adminUserId = 'uu6BugYSuwY9eIng1Mm5qsRh3Lx2';
  const [file, setFile] = useState(null);  // Estado para almacenar el archivo cargado

  const [invoiceData, setInvoiceData] = useState({
    fact_name: '',
    fact_address: '',
    fact_phone: '',
    fact_email: '',
    ruc: '',
    cedula: '',
    fact_purchaseDate: ''
  });
  const [deUnaPage, setDeUnaPage] = useState(false);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalMessage, setModalMessage] = useState("");
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const iva = 1.15;
  const [mostrarTransferencia, setMostrarTransferencia] = useState(false);
  const [isPaypalModalOpen, setIsPaypalModalOpen] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null); // Estado para manejar el estado del pago
  const [ejecutarActualizacion, setEjecutarActualizacion] = useState(false);
  const [adjuntarComprobante, setAdjuntarComprobante] = useState(false);
  const [archivo, setArchivo] = useState(null);
  const [url, setUrl] = useState("");

  const storage = getStorage(appFirebase);
  const firestore = getFirestore(appFirebase);
  const auth = getAuth(appFirebase);
  const ejecutarAccionSegunDispositivo = () => {
    if (window.innerWidth <= 767) {
      // Acción para dispositivos móviles
      console.log("Dispositivo móvil detectado. Realizando acción para móvil...");
      // Aquí puedes llamar a una función específica para móviles
      accionMovil();
    } else {
      // Acción para computadoras de escritorio
      console.log("Dispositivo de escritorio detectado. Realizando acción para escritorio...");
      // Aquí puedes llamar a una función específica para escritorio
      accionEscritorio();
    }
  };

  // Función para dispositivos móviles
  const accionMovil = () => {
    console.log("Ejecutando acción para móviles...");
  };

  // Función para computadoras de escritorio
  const accionEscritorio = () => {
    console.log("Ejecutando acción para escritorio...");
  };
  const subirArchivo = async () => {
    if (!archivo) return alert("Selecciona un archivo");

    try {
      const storageRef = ref(storage, `comprobantes/${archivo.name}`);
      await uploadBytes(storageRef, archivo);

      const urlDescarga = await getDownloadURL(storageRef);
      setUrl(urlDescarga);

      const user = auth.currentUser;
      const comprobanteRef = doc(firestore, "comprobantes", user.uid);

      await setDoc(comprobanteRef, {
        urlComprobante: urlDescarga,
        fecha: new Date().toISOString(),
      });

      alert("Comprobante subido y guardado en Firestore");
    } catch (error) {
      console.error("Error al subir el archivo:", error);
    }
  };
  const handlePaymentStatus = (status) => {


    setPaymentStatus(status);
    // Aquí podrías realizar más acciones, como actualizar los datos del usuario, mostrar un mensaje, etc.
    if (status === 'success') {
      console.log('Pago exitoso, actualizar el estado del usuario.');
      actualizarCoins();

    } else if (status === 'failed') {
      console.log('Hubo un error en el pago.');
    }
    else {
      //console.log('Hubo un error en el pago.',status);
      //actualizarCoins();
    }
  };
  // Mostrar/ocultar el modal de PayPal
  const handlePaypalButtonClick = () => {
    setIsPaypalModalOpen(true); // Abre el modal de PayPal
  };
  const handleFileChange = (event) => {
    setArchivo(event.target.files[0]);
  };

  // Cerrar el modal de PayPal
  const handleClosePaypalModal = () => {
    setIsPaypalModalOpen(false); // Cierra el modal de PayPal
  };


  const actualizarCoins = async () => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      try {
        const userDocRef = doc(db, "usuarios", currentUser.uid);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          const validityTime = selectedPackage.validityTime || 0; // Días de vigencia
          const fechaExpiracion = new Date();
          fechaExpiracion.setDate(fechaExpiracion.getDate() + validityTime);
          const updatedData = {
            coins: selectedPackage.coinAmount + docSnap.data().coins,
            coinsComprados: selectedPackage.coinAmount,
            coinRenovation: new Date(),
            coinExpiration: fechaExpiracion,
          };
          await updateDoc(userDocRef, updatedData);
        }
      } catch (error) {
        console.log(error);
        alert("Error al realizar tu compra");
      }
    }
  };


  // Obtener facturas pendientes (emitida: false)
  const fetchPendingInvoices = async () => {
    setIsLoading(true);
    try {
      const q = query(collection(db, "facturas"), where("emitida", "==", false));
      const querySnapshot = await getDocs(q);
      const fetchedInvoices = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPendingInvoices(fetchedInvoices);
    } catch (error) {
      console.error("Error al obtener facturas pendientes:", error);
      toast.error("Error al cargar facturas pendientes.");
    } finally {
      setIsLoading(false);
    }
  };
  const [validatedPurchases, setValidatedPurchases] = useState([]);

  const handleOpenModal = (invoice, event) => {
    event.preventDefault();
    setSelectedInvoice(invoice);
    setIsValidationModalOpen(true);
  };

  const handleValidateInvoice = async (invoiceId, factName) => {
    try {
      // Referencia al documento de la factura
      const invoiceDocRef = doc(db, "facturas", invoiceId);

      // Obtener los datos de la factura desde Firestore
      const invoiceDoc = await getDoc(invoiceDocRef);
      const invoiceData = invoiceDoc.data();

      if (!invoiceDoc.exists()) {
        console.error("Factura no encontrada.");
        return;
      }

      // Actualizar solo el campo 'emitida' a true
      await updateDoc(invoiceDocRef, { emitida: true });

      // Mostrar el mensaje de validación
      setModalMessage(`La factura de ${factName} ha sido emitida.`);
      setIsValidationModalOpen(false);

      // Actualizar estado local para eliminar la factura de la lista pendiente
      setPendingInvoices((prevInvoices) =>
        prevInvoices.filter((invoice) => invoice.id !== invoiceId)
      );
      toast.success("Factura emitida y generada");

      // Generar el PDF con los datos obtenidos
      generatePDF(invoiceData);

    } catch (error) {
      console.error("Error al validar factura:", error);
      toast.error("Error al validar factura.");
    }
  };

  // Función para obtener el último número de factura desde Firestore
  async function getLastInvoiceNumber() {
    const docRef = doc(db, 'config', 'contador_facturas'); // Documento que contiene el contador de facturas
    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      const data = docSnapshot.data();
      return data.lastInvoiceNumber || 123; // Retornar el número de factura actual o 123 si no existe
    } else {
      return 123; // Si no existe el documento, retornamos un valor por defecto
    }
  }

  // Función para actualizar el contador de factura en Firestore
  async function updateInvoiceCounter(newInvoiceNumber) {
    const docRef = doc(db, 'config', 'contador_facturas'); // Documento para actualizar el contador
    await setDoc(docRef, { numeroFactura: newInvoiceNumber }, { merge: true }); // Actualizamos solo el campo numeroFactura
  }


  // Función para generar el PDF con los datos de la factura
  async function generatePDF(invoiceData) {
    const doc = new jsPDF();

    // Obtener el último número de factura desde Firestore
    let lastInvoiceNumber = await getLastInvoiceNumber();

    // Incrementamos el número de la factura
    lastInvoiceNumber += 1;

    // Formateamos el número de factura con ceros a la izquierda
    const invoiceNumber = String(lastInvoiceNumber).padStart(4, '0');

    // Actualizar el contador de facturas en Firestore
    await updateInvoiceCounter(lastInvoiceNumber);

    // Encabezado principal
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text("LaOfi", 10, 15);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Alquiler de espacios", 10, 20);
    doc.text("Tel: 0990758383 ", 10, 25);
    doc.text("Quito, Av. República de El Salvador", 10, 30);

    // Datos de factura
    doc.setFont("helvetica", "bold");
    doc.text("Factura de Venta", 130, 20);
    doc.text(`No. ${invoiceNumber}`, 160, 20);

    // Datos de cliente
    doc.setFont("helvetica", "normal");
    doc.text("Señor(es):", 10, 40);
    doc.text(invoiceData.fact_name, 40, 40);

    doc.text("NIT/CC:", 110, 40);
    doc.text(invoiceData.cedula || invoiceData.ruc, 140, 40);

    doc.text("Dirección:", 10, 45);
    doc.text(invoiceData.fact_address, 40, 45);

    doc.text("Teléfono:", 110, 45);
    doc.text(invoiceData.fact_phone, 140, 45);

    doc.text("Email:", 10, 50);
    doc.text(invoiceData.fact_email, 40, 50);

    // Tabla de productos/servicios
    doc.rect(10, 55, 190, 100); // Borde de la tabla completa

    // Encabezado de la tabla
    doc.line(10, 65, 200, 65); // Línea horizontal debajo del encabezado
    doc.text("CANT.", 12, 63);
    doc.text("DESCRIPCIÓN", 40, 63);
    doc.text("UNIT.", 150, 63);
    doc.text("TOTAL", 180, 63);

    // Líneas verticales
    doc.line(30, 55, 30, 155);  // Línea entre "CANT." y "DESCRIPCIÓN"
    doc.line(140, 55, 140, 155); // Línea entre "DESCRIPCIÓN" y "UNIT."
    doc.line(170, 55, 170, 155); // Línea entre "UNIT." y "TOTAL"

    // Fila de productos/servicios
    doc.text("1", 12, 73); // Cantidad
    doc.text("Paquete de " + invoiceData.coinAmount + " Coins", 40, 73); // Descripción
    doc.text(invoiceData.price || "0.00", 150, 73); // Precio unitario
    doc.text(invoiceData.price || "0", 180, 73); // Total

    // Total
    doc.setFont("helvetica", "bold");
    doc.rect(140, 155, 30, 10); // Cuadro para la palabra "TOTAL"
    doc.text("TOTAL", 145, 160); // Palabra "TOTAL" dentro del cuadro

    doc.rect(170, 155, 30, 10); // Cuadro para el monto total
    doc.text(invoiceData.price || "0", 175, 160); // Monto total

    // Guardar el PDF
    doc.save("Factura_de_venta.pdf");
  }


  // Cerrar modal
  const closeModal = () => {
    setIsModalOpen(false);
    setModalMessage("");
  };

  useEffect(() => {
    fetchPendingInvoices();
  }, []);



  useEffect(() => {
    fetchCoinPackages();
    fetchPendingPurchases();
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDocRef = doc(db, 'usuarios', currentUser.uid);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          setRole(docSnap.data().role);
        }
      }
    });

    return () => unsubscribe();
  }, []);


  const fetchCoinPackages = async () => {
    const q = query(collection(db, 'coinPackages'), where('active', '==', true));
    const querySnapshot = await getDocs(q);

    const packages = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));

    setCoinPackages(packages);
  };


  const fetchPendingPurchases = async () => {
    try {
      // Obtenemos las compras pendientes
      const querySnapshot = await getDocs(collection(db, 'comprasPendientes'));

      // Filtramos las compras donde validated está en estado false
      const pendingDocs = querySnapshot.docs.filter((doc) => {
        const purchaseData = doc.data();
        return purchaseData.validated === false; // Solo compras no validadas
      });

      // Procesamos las compras pendientes
      const purchases = await Promise.all(
        pendingDocs.map(async (doc) => {
          const purchaseData = doc.data();
          const userId = purchaseData.userId; // Supongamos que tienes el userId en cada compra

          // Obtenemos el nombre completo del usuario
          const fullName = await fetchUserDetails(userId);

          return {
            id: doc.id,
            ...purchaseData,
            fullName, // Agregamos el nombre completo de usuario a la compra
          };
        })
      );

      // Guardamos las compras pendientes con el nombre completo del usuario
      setPendingPurchases(purchases);
    } catch (error) {
      console.error("Error al obtener las compras pendientes: ", error);
    }
  };


  const fetchUserDetails = async (userId) => {
    try {
      const userDocRef = doc(db, 'usuarios', userId);  // Referencia al documento del usuario
      const userDocSnap = await getDoc(userDocRef);  // Obtenemos el documento

      if (userDocSnap.exists()) {
        const userData = userDocSnap.data(); // Datos del usuario
        const fullName = `${userData.name} ${userData.lastName}`; // Concatenamos el nombre y el apellido
        return fullName;
      } else {
        console.error("No se encontró el usuario con ID: ", userId);
        return null;
      }
    } catch (error) {
      console.error("Error al obtener los detalles del usuario: ", error);
      return null;
    }
  };
  const fetchValidatedPurchases = async () => {
    try {
      // Obtenemos las compras de Firestore
      const querySnapshot = await getDocs(collection(db, 'comprasPendientes'));

      // Filtramos las compras donde validated está en estado true
      const validatedDocs = querySnapshot.docs.filter((doc) => {
        const purchaseData = doc.data();
        return purchaseData.validated === true; // Solo compras validadas
      });

      // Procesamos las compras validadas
      const purchases = await Promise.all(
        validatedDocs.map(async (doc) => {
          const purchaseData = doc.data();
          const userId = purchaseData.userId;

          // Obtenemos el nombre completo del usuario
          const fullName = await fetchUserDetails(userId);

          return {
            id: doc.id,
            ...purchaseData,
            fullName, // Agregamos el nombre completo del usuario a la compra
          };
        })
      );

      // Guardamos las compras validadas
      setValidatedPurchases(purchases);
    } catch (error) {
      console.error("Error al obtener las compras validadas: ", error);
    }
  };

  useEffect(() => {
    if (user && user.uid === adminUserId) {
      fetchValidatedPurchases();
    }
  }, [user]);

  const handlePurchase = (pkg) => {
    setSelectedPackage(pkg); // Establece el paquete seleccionado
    setIsModalOpen(true); // Abre el modal de compra
  };

  const generateGuestId = () => {
    // Intentar obtener un ID existente de localStorage
    let guestId = localStorage.getItem("guestId");

    if (!guestId) {
      // Generar un nuevo ID único
      guestId = `guest_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
      localStorage.setItem("guestId", guestId);
    }

    return guestId;
  };


  const handleConfirmPurchase = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    subirArchivo();
    const userId = user?.uid || generateGuestId();
    const userName = user?.displayName || "Invitado";
    const userEmail = user?.email || "Sin email";
    if (!selectedPackage) {
      toast.error("Por favor, selecciona un paquete para comprar.");
      return;
    }

    try {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      let message = '';
      if (currentHour >= 7 && (currentHour < 17 || (currentHour === 17 && currentMinute <= 30))) {
        message = 'Su compra será validada entre 30 minutos y 1 hora.';
      } else {
        message = 'Su compra será validada a las 7:00 de la mañana siguiente.';
      }

      // Crear la compra en Firestore
      const purchaseDocRef = doc(collection(db, 'comprasPendientes'));
      const purchaseId = purchaseDocRef.id;

      await setDoc(purchaseDocRef, {
        userId,
        coinAmount: selectedPackage.coinAmount, // Registrar coinAmount
        purchaseDate: now,
        validated: false,
        price: selectedPackage.price, // Registrar price
        packageId: selectedPackage.id,
        comprobante: url,
      });

      // Guardar los valores en sessionStorage
      sessionStorage.setItem('coinAmount', selectedPackage.coinAmount);
      sessionStorage.setItem('price', selectedPackage.price);

      // Registrar clic en Firestore
      const userDocRef = doc(db, "Interacciones", userId);
      const userDoc = await getDoc(userDocRef);

      if (!userDoc.exists()) {
        await setDoc(userDocRef, {
          nombre: userName,
          email: userEmail,
          clics: {},
        });
      }

      const { coinAmount, price } = selectedPackage;
      const membershipKey = `Membresias.${coinAmount}_${price}`;

      await updateDoc(userDocRef, {
        [`clics.${membershipKey}.contador`]: increment(1),
        [`clics.${membershipKey}.ultimoClic`]: now,
        [`clics.${membershipKey}.coinAmount`]: coinAmount,
        [`clics.${membershipKey}.price`]: price,
      });

      setConfirmationMessage(`Compra de ${selectedPackage.coinAmount} coins registrada. ${message}`);
      toast.success("Compra realizada");
      setIsModalOpen(false);
      setIsConfirmationModalOpen(true);
      setSelectedPackage(null);
      fetchPendingPurchases();
      fetchPendingInvoices();
    } catch (error) {
      console.error("Error al registrar la compra: ", error);
      toast.error("Error al registrar la compra. Inténtalo de nuevo.");
    }
  };




  const handleValidatePurchase = async (purchaseId, userId, coinAmount) => {
    if (!purchaseId || !userId) {
      console.error("purchaseId o userId no definidos");
      toast.error("Error: Identificador de compra o usuario no disponible.");
      return;
    }

    // Verifica si el usuario actual es el admin específico
    if (user.uid !== adminUserId) {
      toast.error("No tienes permisos para validar esta compra.");
      return;
    }

    const purchaseDocRef = doc(db, 'comprasPendientes', purchaseId);
    const userDocRef = doc(db, 'usuarios', userId);

    try {
      // Obtener los datos de la compra pendiente
      const purchaseSnap = await getDoc(purchaseDocRef);
      if (!purchaseSnap.exists()) {
        toast.error("No se encontró el registro de compra pendiente.");
        return;
      }

      const purchaseData = purchaseSnap.data();
      // Marcar la compra como validada
      await updateDoc(purchaseDocRef, { validated: true });

      // Obtener el documento del usuario
      const userDocSnap = await getDoc(userDocRef);
      if (userDocSnap.exists()) {
        const userData = userDocSnap.data();
        const currentCoins = userData.coins || 0;

        // Actualizar los campos del usuario
        await updateDoc(userDocRef, {
          coins: currentCoins + coinAmount,
          coinsComprados: (userData.coinsComprados || 0) + coinAmount,
          purchaseDate: purchaseData.purchaseDate, // Agregar la fecha de compra (Guarda como Timestamp)
        });

        toast.success("Compra validada");

        // Actualizar la lista de compras pendientes
        fetchPendingPurchases();
        fetchValidatedPurchases();
      } else {
        toast.error("No se encontró el usuario para actualizar.");
      }
    } catch (error) {
      console.error("Error al validar o eliminar la compra: ", error);
      toast.error("Error al validar o eliminar la compra.");
    }
  };

  const handleInvoiceChange = (e) => {
    const { name, value } = e.target;

    // Si ya hay un valor en el campo RUC o Cédula, no se permite escribir en el otro
    if ((name === 'cedula' && invoiceData.ruc) || (name === 'ruc' && invoiceData.cedula)) {
      // Si el otro campo tiene un valor, no hace nada
      return;
    }

    // Validar Cédula (10 números)
    if (name === 'cedula') {
      // Solo permitir números y un máximo de 10 caracteres
      if (/^\d{0,10}$/.test(value)) {
        setInvoiceData(prevState => ({
          ...prevState,
          [name]: value
        }));
      }
    }

    // Validar RUC (13 números)
    else if (name === 'ruc') {
      // Solo permitir números y un máximo de 13 caracteres
      if (/^\d{0,13}$/.test(value)) {
        setInvoiceData(prevState => ({
          ...prevState,
          [name]: value
        }));
      }
    }

    // Para el resto de campos, solo actualizar su valor sin validación especial
    else {
      setInvoiceData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleInvoiceSubmit = async () => {
    setIsConfirmationModalOpen(false);

    const checkEmptyField = (fieldValue) => {
      return !fieldValue || fieldValue.trim() === '';
    };

    // Validar campos obligatorios
    if (
      checkEmptyField(invoiceData.fact_name) ||
      checkEmptyField(invoiceData.fact_address) ||
      checkEmptyField(invoiceData.fact_phone) ||
      checkEmptyField(invoiceData.fact_email) ||
      checkEmptyField(invoiceData.fact_purchaseDate)
    ) {
      toast.error('Por favor, completa todos los campos obligatorios.', {
        autoClose: 3000,
      });
      return;
    }

    // Validar la cédula
    if (invoiceData.cedula && invoiceData.cedula.trim().length !== 10) {
      toast.error('La cédula debe tener 10 dígitos.', {
        autoClose: 3000,
      });
      return;
    }

    // Validar el RUC
    if (invoiceData.ruc && invoiceData.ruc.trim().length !== 13) {
      toast.error('El RUC debe tener 13 dígitos.', {
        autoClose: 3000,
      });
      return;
    }

    // Recuperar los valores de coinAmount y price de sessionStorage
    const coinAmount = sessionStorage.getItem('coinAmount');
    const price = sessionStorage.getItem('price');

    if (!coinAmount || !price) {
      toast.error('No se encontraron los datos de la compra.', {
        autoClose: 3000,
      });
      return;
    }

    // Obtener el último número de factura desde Firestore
    const invoiceCounterRef = doc(db, 'config', 'contador_facturas');
    const invoiceCounterSnapshot = await getDoc(invoiceCounterRef);

    let invoiceNumber = 1; // Número por defecto si no existe el contador
    if (invoiceCounterSnapshot.exists()) {
      invoiceNumber = invoiceCounterSnapshot.data().lastInvoiceNumber + 1;
    }

    // Formatear el número de factura a 3 dígitos
    const formattedInvoiceNumber = String(invoiceNumber).padStart(3, '0');

    // Crear objeto con la información de la factura
    const invoiceDataToSave = {
      fact_email: invoiceData.fact_email,
      fact_address: invoiceData.fact_address,
      fact_phone: invoiceData.fact_phone,
      fact_name: invoiceData.fact_name,
      fact_purchaseDate: invoiceData.fact_purchaseDate,
      idUser: user.uid,
      coinAmount: coinAmount, // Usar coinAmount
      price: price, // Usar price
      emitida: false,
      invoiceNumber: formattedInvoiceNumber, // Guardar el número de factura
    };

    // Si existe cédula, agregarla a los datos de la factura
    if (invoiceData.cedula) {
      invoiceDataToSave.cedula = invoiceData.cedula;
    }

    // Si existe RUC, agregarlo a los datos de la factura
    if (invoiceData.ruc) {
      invoiceDataToSave.ruc = invoiceData.ruc;
    }

    try {
      // Registrar la factura en Firestore
      const invoiceDocRef = doc(collection(db, 'facturas'));
      await setDoc(invoiceDocRef, invoiceDataToSave);

      // Actualizar el contador de facturas en Firestore
      await setDoc(invoiceCounterRef, { lastInvoiceNumber: invoiceNumber });

      // Actualizar el usuario con la cédula y/o RUC si no existe
      const userDocRef = doc(db, 'usuarios', user.uid);
      const userSnapshot = await getDoc(userDocRef);

      if (userSnapshot.exists()) {
        const userData = userSnapshot.data();
        const userUpdateData = {};

        if (!userData.cedula && invoiceData.cedula) {
          userUpdateData.cedula = invoiceData.cedula;
        }

        if (!userData.ruc && invoiceData.ruc) {
          userUpdateData.ruc = invoiceData.ruc;
        }

        if (Object.keys(userUpdateData).length > 0) {
          await setDoc(userDocRef, userUpdateData, { merge: true });
        }
      }

      toast.success('Factura guardada correctamente.', {
        autoClose: 3000,
      });
      fetchPendingInvoices();

      // Limpiar los valores de sessionStorage después de guardar la factura
      sessionStorage.removeItem('coinAmount');
      sessionStorage.removeItem('price');

      setIsInvoiceModalOpen(false);
    } catch (error) {
      console.error('Error al guardar la factura o actualizar el usuario:', error);
      toast.error('Error al guardar los datos. Intenta nuevamente.', {
        autoClose: 3000,
      });
    }
  };



  useEffect(() => {
    if (isInvoiceModalOpen) {
      setIsConfirmationModalOpen(false)
      setInvoiceData((prevData) => ({
        ...prevData,
        fact_purchaseDate: new Date().toISOString().split('T')[0], // Fecha actual
      }));
    }
  }, [isInvoiceModalOpen, setInvoiceData]);

  return (
    <div>
      <Navbar />
      <ToastContainer />
      <br /><br />
      <div className="coin-purchase-container">
        <h2 className="card-title">LaOfi Wallet</h2>
        <div className="package-flex">
          {coinPackages.map((pkg, index) => (
            <div
              key={pkg.id}
              className="coin-card"
              style={{
                '--package-color': pkg.color,
                '--animation-delay': `${index * 0.1}s` // Escalona la animación
              }}
            >
              <div className='container-coins'>
                <div className="coin-card-header">
                  <h3 className="package-name" style={{ color: pkg.color }}>
                    {pkg.packageName}
                  </h3>
                  <i className={pkg.icon} style={{ color: pkg.color }}></i>
                </div>
                <p className="price">
                  ${pkg.price.toFixed(2)}
                  <p style={{ color: 'white', marginTop: '-8px' }}>Más Impuestos</p>

                </p>
                <p className="coin-amount">{pkg.coinAmount} coins</p>
                <span style={{ color: 'white', fontSize: '12px' }}>*Tiempo de Vigencia {pkg.validityTime} dias</span>



                <button
                  onClick={() => handlePurchase(pkg)}
                  style={{ color: pkg.color }}
                >
                  Activa tu plan
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* Modal para confirmar compra */}
      {isModalOpen && selectedPackage && selectedPackage.coinAmount && selectedPackage.price && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 className="modal-title"></h3>

            {/* Métodos de pago */}
            {!mostrarTransferencia ? (

              <div className="payment-methods">
                {!adjuntarComprobante && (<>
                  <button className="payment-btn" onClick={() => { setMostrarTransferencia(true) }}>
                    <FaUniversity size={30} className="payment-icon" />
                    <span> Transferencia Bancaria</span>
                  </button>
                  <button className="payment-btn" onClick={handlePaypalButtonClick}>
                    <FaCreditCard size={30} className="payment-icon" />
                    <span> Tarjeta de Crédito/Débito</span>
                  </button>
                  <a href='https://pagar.deuna.app/H92p/U2FsdGVkX1+hCsus/BpH/TpSwg+Up6Xneg9yI1Ma37SRiQ3lcP7Gcgakj1BWw5zToGL48ZPlGr9y/ov7OTtd6T4Ch8+IfnQdQg8EMz8nAPwLmMFRXEcG+vXL3uXPRhNjsiB97m6KMLZ+glktHl4ZbstuFLl7mCJeF+C7vnXzJ0d7RIW+TE27ipLpegePYboeHQhj8ZvpBvSqaWHHduMbDQ==' target="_blank">
                    <button className="payment-btn" onClick={() => setDeUnaPage(true)}>
                      <img src={DeUnaLogo} alt="DeUna" className="payment-icon" width={30} height={30} />
                      <span>  DeUna </span>
                    </button>
                  </a>
                  {
                    deUnaPage && (
                      <>
                      </>
                    )
                  }
                </>

                )}



                {/* Modal de PayPal */}
                {isPaypalModalOpen && (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <h3>Pago con PayPal</h3>
                      <p>Seleccione su método de pago y complete la transacción.</p>

                      {/* Botón de PayPal */}
                      <PaypalButton
                        selectedPackage={selectedPackage}
                        onPaymentStatus={handlePaymentStatus}
                      />

                      {/* Mostrar el estado del pago */}
                      {paymentStatus && (
                        <div>
                          {paymentStatus === 'success' ? (
                            <p>¡Pago exitoso! Gracias por tu compra.</p>
                          ) : paymentStatus === 'failed' ? (
                            <p>Hubo un error con el pago. Inténtalo nuevamente.</p>
                          ) : (
                            <p>Esperando pago...</p>
                          )}
                        </div>
                      )}

                      <button onClick={handleClosePaypalModal} className='btn-cerrar'>Cerrar</button>
                    </div>
                  </div>
                )}

              </div>
            ) : (

              <div className="transferencia-info">
                {!adjuntarComprobante && (
                  <>
                    <h4>Datos de la cuenta</h4>
                    <img src={ProdubancoLogo} alt="logo" className="produbanco-logo" />
                    <p><strong>Cuenta:</strong> 27059084400</p>
                    <p><strong>Nombre:</strong> INNOVACIÓN COLABORATIVA Y DESARROLLO DE NEGOCIOS LAOFI S.A.S.  </p>
                    <p><strong>RUC/Identificación:</strong> 1793223655001</p>
                    <p><strong>email:</strong> info@laofi.work</p>
                    <p><strong>Referencia:</strong> Recarga de Coins</p>

                    <button
                      onClick={() => setAdjuntarComprobante(true)}
                      className='btn-volver'
                    >
                      Adjuntar Comprobante de Pago
                    </button>
                    <p></p>
                    <button className="btn-volver" onClick={() => setMostrarTransferencia(false)}>
                      Volver
                    </button>
                  </>

                )}



              </div>
            )}{
              adjuntarComprobante && (
                <div className="">
                  <h3 className="modal-title">Adjuntar comprobante</h3>

                  {/* Campo para subir archivo */}
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleFileChange} // función que puedes definir para manejar el archivo
                  />

                  <div>
                    <button
                      onClick={() => handleConfirmPurchase()}
                      className='btn-confirmar-pago'
                      disabled={!archivo}  // Deshabilitar el botón si no hay archivo cargado

                    >
                      Confirmar Pago
                    </button>
                    <button
                      className="btn-volver"
                      onClick={() => setAdjuntarComprobante(false)}
                    >
                      Volver
                    </button>
                  </div>
                </div>
              )
            }


            {/* Botón de cerrar */}
            <button className="btn-cerrar" onClick={() => setIsModalOpen(false)}>
              Cerrar
            </button>
          </div>
        </div>
      )}




      {/* Tabla de compras pendientes visible solo para el admin especificado */}
      {user && user.uid === adminUserId && (
        <div className="pending-purchases">
          <h2>Cobros Pendientes</h2>
          <table className='tabla-pendiente'>
            <thead>
              <tr>
                <th>Nombre del Usuario</th>
                <th>Cantidad de coins</th>
                <th>Valor cancelado</th>
                <th>Fecha de Compra</th>
                <th>Validar</th>
              </tr>
            </thead>
            <tbody>
              {pendingPurchases.map((purchase) => (
                <tr key={purchase.id}>
                  <td>{purchase.fullName}</td>  {/* Mostrar el nombre completo aquí */}
                  <td>{purchase.coinAmount}</td>
                  <td>{purchase.price} USD</td> {/* Mostrar el precio aquí */}
                  <td>{purchase.purchaseDate?.toDate().toLocaleString()}</td>
                  <td>
                    <button onClick={() => handleValidatePurchase(purchase.id, purchase.userId, purchase.coinAmount)}>Validar Compra</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Tabla de compras validadas visible solo para el admin especificado */}
      {user && user.uid === adminUserId && (
        <div className="pending-purchases">
          <h2>Cobros Validados</h2>
          <table className='tabla-pendiente'>
            <thead>
              <tr>
                <th>Nombre del Usuario</th>
                <th>Cantidad de coins</th>
                <th>Valor cancelado</th>
                <th>Fecha de Compra</th>
              </tr>
            </thead>
            <tbody>
              {validatedPurchases.map((purchase) => (
                <tr key={purchase.id}>
                  <td>{purchase.fullName}</td> {/* Mostrar el nombre completo aquí */}
                  <td>{purchase.coinAmount}</td>
                  <td>{purchase.price} USD</td> {/* Mostrar el precio aquí */}
                  <td>{purchase.purchaseDate?.toDate().toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal de confirmación de compra */}
      {isConfirmationModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Confirmación de Compra</h3>
            <p>{confirmationMessage}</p>
            <button onClick={() => setIsInvoiceModalOpen(true)} style={{ backgroundColor: '#ff6300', marginRight: '20px' }}>Desea Factura</button>
            <button onClick={() => setIsConfirmationModalOpen(false)} style={{ backgroundColor: '#00359f' }}>Consumidor Final </button>
          </div>
        </div>
      )}

      {/* Modal para ingresar datos de factura */}
      {isInvoiceModalOpen && (
        <div className="modal-overlay-custom">
          <div className="modal-content-custom">
            <h3 className="modal-title">Ingresar Datos de Factura</h3>
            <div className="labels_fact-custom">
              <div className="label-item-custom">
                <label htmlFor="fact_name" className="label-custom">Nombres/Razón Social:</label>
                <input
                  id="fact_name"
                  className="input-custom"
                  type="text"
                  name="fact_name"
                  value={invoiceData.fact_name}
                  onChange={handleInvoiceChange}
                />
              </div>
              <div className="label-item-custom">
                <label htmlFor="fact_address" className="label-custom">Dirección:</label>
                <input
                  id="fact_address"
                  className="input-custom"
                  type="text"
                  name="fact_address"
                  value={invoiceData.fact_address}
                  onChange={handleInvoiceChange}
                />
              </div>
              <div className="label-item-custom">
                <label htmlFor="fact_phone" className="label-custom">Teléfono:</label>
                <input
                  id="fact_phone"
                  className="input-custom"
                  type="text"
                  name="fact_phone"
                  value={invoiceData.fact_phone}
                  onChange={handleInvoiceChange}
                />
              </div>
              <div className="label-item-custom">
                <label htmlFor="fact_email" className="label-custom">Correo:</label>
                <input
                  id="fact_email"
                  className="input-custom"
                  type="email"
                  name="fact_email"
                  value={invoiceData.fact_email}
                  onChange={handleInvoiceChange}
                />
              </div>
              <div className="label-item-custom">
                <label htmlFor="cedula" className="label-custom">Cédula:</label>
                <input
                  id="cedula"
                  className="input-custom"
                  type="text"
                  name="cedula"
                  value={invoiceData.cedula}
                  onChange={handleInvoiceChange}
                  disabled={invoiceData.ruc !== ""} // Deshabilita si RUC ya tiene valor
                />
              </div>
              <div className="label-item-custom">
                <label htmlFor="ruc" className="label-custom">RUC:</label>
                <input
                  id="ruc"
                  className="input-custom"
                  type="text"
                  name="ruc"
                  value={invoiceData.ruc}
                  onChange={handleInvoiceChange}
                  disabled={invoiceData.cedula !== ""} // Deshabilita si Cédula ya tiene valor
                />
              </div>

            </div>
            <button className="button-save" onClick={handleInvoiceSubmit}>Guardar Factura</button>
          </div>
        </div>
      )}



      {/* Modal de validación de compra */}
      {isValidationModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Validación de Compra</h3>
            <p>{validationMessage}</p>
            <button onClick={() => setIsValidationModalOpen(false)}>Cerrar</button>

          </div>
        </div>
      )}
      {user && user.uid === adminUserId && (
        <div className="pending-invoices">
          <h2>Facturas Pendientes de Emisión</h2>
          {isLoading ? (
            <p>Cargando facturas...</p>
          ) : pendingInvoices.length === 0 ? (
            <p>No hay facturas pendientes de emisión.</p>
          ) : (
            <table className="tabla-pendiente">
              <thead>
                <tr>
                  <th>Nombres/Razón Social</th>
                  <th>Cédula o RUC</th>
                  <th>Emitida</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {pendingInvoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td>{invoice.fact_name}</td>
                    <td>{invoice.cedula || invoice.ruc}</td>
                    <td>{invoice.emitida ? "Sí" : "No"}</td>
                    <td>
                      <button onClick={(event) => handleOpenModal(invoice, event)}>Ver datos</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
      {/* Modal de validación de compra */}
      {isValidationModalOpen && selectedInvoice && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Detalles de la Factura</h3>
            <p><strong>Nombres/Razón Social:</strong> {selectedInvoice.fact_name}</p>
            <p><strong>Cédula o RUC:</strong> {selectedInvoice.cedula || selectedInvoice.ruc}</p>
            <p><strong>Fecha de Compra:</strong> {selectedInvoice.fact_purchaseDate}</p>
            <p><strong>Dirección:</strong> {selectedInvoice.fact_address}</p>
            <p><strong>Email:</strong> {selectedInvoice.fact_email}</p>
            <p><strong>Teléfono:</strong> {selectedInvoice.fact_phone}</p>

            {/* Nuevos campos a mostrar */}
            <p><strong>Cantidad de Monedas:</strong> {selectedInvoice.coinAmount}</p>
            <p><strong>Precio:</strong> ${selectedInvoice.price}</p>

            <div className="modal-actions">
              <button
                onClick={() =>
                  handleValidateInvoice(selectedInvoice.id, selectedInvoice.fact_name)
                }
              >
                Validar Factura
              </button>
              <button onClick={() => setIsValidationModalOpen(false)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}


      <div className="contenedor-imagenes">
        <img src={Lateral3} alt="imagen" className="imagen-lateral3" />
        <img src={Lateral4} alt="imagen" className="imagen-lateral4" />
        <img src={Lateral5} alt="imagen" className="imagen-lateral5" />
      </div>
      <Footer />
    </div>
  );

};

export default Membresias;
